import React from 'react';
import FadeIn from '../common/FadeIn';
import about1 from '../../assets/images/about1.png';

const AboutWhySection = () => {
  return (
    <section className="w-full bg-[#38404A] text-white sticky top-0 z-10 min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 items-stretch min-h-screen">

        <FadeIn className="w-full h-full min-h-[320px] sm:min-h-[420px] lg:min-h-full self-stretch bg-[#2E343C] flex items-center justify-center relative overflow-hidden">
          <img
            src={about1}
            alt="Princy Patel - SeaSalt Creative Studio & Website Design Showcase"
            className="w-full h-full object-cover object-center"
            loading="lazy"
            decoding="async"
            width="600"
            height="800"
          />
        </FadeIn>

        <div className="w-full bg-[#38404A] flex flex-col justify-center p-8 sm:p-12 md:p-16 lg:p-20">
          <div className="max-w-[540px]">
            <FadeIn>
              <h2 className="font-saolDisplayItalic md:text-[70px] text-[40px] leading-[1] font-normal tracking-[0em] mb-7 sm:mb-9">
                Why I Do This
              </h2>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-white leading-[1.6] tracking-[0em] mb-6">
                Hi, I am Princy Patel. I wanted to make the website process easier for people who do not want to start everything from scratch.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-white leading-[1.6] tracking-[0em] mb-6">
                You choose a design you like, send me your content and brand details, and I take care of the rest.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] sm:text-[17px] font-light text-white leading-[1.75]">
                I handle the changes, layout, and small details to make the website fit your business and look the way you want.
              </p>
            </FadeIn>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutWhySection;
